const URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:8080/giro/api/v1";

const API = {
    events: {
    operations: {
      get:    (id: string | number) => URL + `/events/${id}`,
      create: URL + '/events/create',
      update: URL + '/events/update',
      stats:  URL + '/events/stats',
    },
    filter: {
      search:  URL + '/filter/events/search',
      options: URL + '/filter/events/create',
    },
    recovery: {
      list:   (eventId: string | number) => URL + `/events/recovery/${eventId}`,
      create: URL + '/events/recovery/create',
    },
    tracking: {
      list:   (eventId: string | number) => URL + `/events/tracking/${eventId}`,
      create: URL + '/events/tracking',
    },
  },
  issues: {
    operations: {
      get: (id: string | number) => URL + `/issues/${id}`,
      update: URL + '/issues/update',
      create: URL + '/issues/create',
      approve: URL + '/issues/approve'
    },
    assessment: {
      issue: URL + '/assessment/issue',
    },
    monitoring: {
      // Activity & monitoring track entries. NOTE: {idIssue} is the NUMERIC issue id
      // (issueData.id), not the route UID — the backend does Long.valueOf(idIncident).
      list: (idIssue: string | number) => URL + `/issues/monitoring/${idIssue}/actives`,
      save: URL + '/issues/monitoring',
      update: URL + '/issues/monitoring',
      delete: (uid: string) => URL + `/issues/monitoring/${uid}`,
      updateAttachmentIndicator: URL + '/issues/monitoring/update-attachment-indicator',
    },
    file: {
      upload: URL + '/s3/files/upload',
      list: URL + '/s3/files',
      delete: URL + '/s3/files/delete',
      download: URL + '/s3/files/download',
    },
  },
  filter: {
    issues: {
      create: URL + '/filter/create',
      search: URL + '/filter/search'
    }
  },
  status: {
    list: URL + '/status',
    create: URL + '/status',
    update: (id: string | number) => URL + `/status/${id}`,
    delete: (id: string | number) => URL + `/status/${id}`,
    entities: URL + '/status/entities'
  },
  settings: {
    emailServer: {
      // Planned giro-admin endpoints (not implemented in the backend yet).
      // GET must return the config WITHOUT the password (expose passwordSet
      // instead); POST updates the password only when a new value is sent.
      get: URL + '/integration-config/email',
      save: URL + '/integration-config/email',
      test: URL + '/integration-config/email/test'
    },
    notifications: {
      // channel defaults to EMAIL server-side; the UI never offers another
      // channel today, so it is never sent explicitly (design §5).
      get: URL + '/notification-settings',
      save: URL + '/notification-settings',
      template: (code: string, locale: string) =>
        URL + `/notification-settings/${code}/template?locale=${encodeURIComponent(locale)}`,
      resetTemplate: (code: string, locale: string) =>
        URL + `/notification-settings/${code}/template?locale=${encodeURIComponent(locale)}`
    }
  },
  parameters: {
    common: {
      option: {
        list: URL + '/foreign-keys/showListForeignKeysByTableName'
      },
      status: {
        list: URL + '/status/findStateIncident'
      },
      process: {
        // Consolidated process hierarchy (single table, stable_id-keyed).
        // The legacy /process/actives-old endpoint was removed in Phase 12.
        tree: URL + '/processes/tree',
        byStableId: (stableId: string) => URL + `/processes/${stableId}`,
        children: (stableId: string) => URL + `/processes/${stableId}/children`,
        activeVersion: URL + '/processes/active-version'
      },
      area: {
        list: URL + '/area/actives'
      },
      user: {
        list: URL + '/user/searchUser'
      }
    },
    config: {
      assessment: {
        groups: URL + '/config-assessment/groups',
        variables_group: URL + '/config-assessment/variables-group',
        variables: URL + '/config-assessment/variables',
        values: URL + '/config-assessment/values',
        scaleBands: URL + '/scale-band'
      }
    }
  }
};

export default API;
